'use client'

import { useI18n } from '@/lib/i18n/context'
import { ImpactRadarSvg, type ImpactRadarProps } from './ImpactRadarSvg'

/**
 * Radar d'impact du site public : lit la langue dans le contexte de
 * traduction et délègue le dessin à `ImpactRadarSvg` (partagé avec l'espace
 * contributeur, qui n'a pas ce contexte).
 */
export default function ImpactRadar(props: ImpactRadarProps) {
  const { locale } = useI18n()
  return <ImpactRadarSvg {...props} locale={locale} />
}
